import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { toastMessageInterface, toastOptionInterface } from '../common/interface/common.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private alert: Subject<toastMessageInterface> = new Subject();
  public alert$: Observable<toastMessageInterface> = this.alert.asObservable();

  constructor() { }

  public error(message: string, option: toastOptionInterface | undefined = undefined) {
    this.execute("ERROR", message, option);
  }

  public success(message: string, option: toastOptionInterface | undefined = undefined) {
    this.execute("SUCCESS", message, option);
  }

  public warn(message: string, option: toastOptionInterface | undefined = undefined) {
    this.execute("WARNING", message, option);
  }

  public info(message: string, option: toastOptionInterface | undefined = undefined) {
    this.execute("INFO", message, option);
  }

  public clear() {
    this.execute("CLEAR", "");
  }

  private execute(type:toastMessageInterface["type"], message: string, option: toastOptionInterface | undefined = undefined) {
    let toastData: toastMessageInterface = {
      type,
      message,
      progressBar: undefined,
      closeButton: undefined
    }
    if (option)  {
      toastData = { ...toastData, ...option }
    }
    this.alert.next(toastData)
  }
}
